import React from "react";
import { aboutData } from "../data/mock";
import { Badge } from "./ui/badge";
import { Separator } from "./ui/separator";
import { Sparkles } from "lucide-react";

const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal-600/30 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-teal-600/30 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section header */}
        <div className="flex items-center gap-3 mb-16">
          <Sparkles className="w-5 h-5 text-teal-400" />
          <span className="font-nunito text-teal-400 text-sm tracking-[0.25em] uppercase font-semibold">
            Sobre ella
          </span>
          <div className="flex-1 h-px bg-teal-500/20" />
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image column */}
          <div className="relative group">
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src={aboutData.image}
                alt="Aurie Cano"
                className="w-full h-[500px] object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <span className="font-bebas text-3xl text-white tracking-wide">{aboutData.fullName}</span>
              </div>
            </div>
            {/* Decorative frame */}
            <div className="absolute -top-3 -left-3 w-24 h-24 border-t-2 border-l-2 border-teal-600/40 rounded-tl-2xl" />
            <div className="absolute -bottom-3 -right-3 w-24 h-24 border-b-2 border-r-2 border-teal-600/40 rounded-br-2xl" />
          </div>

          {/* Text column */}
          <div className="backdrop-blur-md rounded-2xl p-6">
            <h2 className="font-bebas text-5xl md:text-6xl text-black lg:text-teal-400 tracking-wide mb-6">
              La <span className="text-teal-400">Chilerísima</span>
            </h2>

            <p className="font-nunito text-lg text-slate-200 leading-relaxed mb-6">{aboutData.bio}</p>

            <Separator className="bg-teal-500/20 my-6" />

            <p className="font-nunito text-base text-slate-200 leading-relaxed mb-8">{aboutData.extendedBio}</p>

            <div className="mb-8">
              <span className="font-nunito text-sm text-teal-400 uppercase tracking-wider font-semibold mb-4 block">
                Su versatilidad le ha permitido destacar como:
              </span>
              <div className="flex flex-wrap gap-2 mt-3">
                {aboutData.roles.map((role, index) => (
                  <Badge
                    key={index}
                    variant="outline"
                    className="border-teal-600/40 text-teal-400 font-nunito text-sm px-4 py-1.5 hover:bg-teal-500/10 hover:border-teal-500/50 transition-all duration-300 cursor-default"
                  >
                    {role}
                  </Badge>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
